/* globals jQuery */
import 'fitvids.1.1.0'

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

import './effects.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    $('#categoryFilter').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

	// Hero onscroll opacity
	let opacity = 1;
	let offset = 1;
	let zIndex = 1
	let windowHeight = $(document).height() / 1;
	$(window).on('scroll', function (e) {
		e.preventDefault();
		offset = 1 - (windowHeight / Math.min(windowHeight - $(window).scrollTop(),windowHeight));
		opacity = 1 - Math.abs(Math.min(1, offset * 3));
		zIndex = -Math.floor(Math.min(1, offset * 3));
		zIndex = -zIndex + 2
		$('.hero-wrapper, .hero-interior-wrapper').css({'opacity': opacity, 'z-index': zIndex});
	});

	// When the user scrolls down 50px from the top of the document, resize the header's font size
	window.onscroll = function() {scrollFunction()};
		function scrollFunction() {
		if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
			$( "#js-header" ).addClass( "scrolling" );
		} else {
			$( "#js-header" ).removeClass( "scrolling" );
		}
	}

})(jQuery)
